export default __webpack_public_path__ + "static/media/logo_light_background.678d5cda.png";